const paths = {
  check_icon: `M 0.808 11.136
               C 0.136 8.352 2.536 7.008 4.648 8.352
               L 8.872 12.864 L 19.624 3.456
               C 22.12 2.112 24.136 4.224 23.08 6.624
               L 11.656 16.704
               C 9.832 18.144 8.104 18.816 5.704 16.704
               Z`
} as const;

export type PathName = keyof typeof paths;

export default paths;
